import $ from 'jquery';
import 'slick-carousel';

const slickSettings = {
  fade: true,
  dots: true,
  arrows: false,
};

export default class Videos {
  constructor(element) {
    this.$element = $(element);
    this.settings = slickSettings;
    this.slick = this.addSlickCarousel();
    this.ready();
  }

  addSlickCarousel() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
